module.exports = __webpack_public_path__ + "static/Booklets-0506f8d044c4da283c7191a4250b5a89.svg";